function formatDate(date: Date, type: string = "dd/mm/yyyy hh:mm:ss") {
  const seconds = String(date.getSeconds()).padStart(2, "0")
  const minutes = String(date.getMinutes()).padStart(2, "0")
  const hours = String(date.getHours()).padStart(2, "0")
  const day = String(date.getDate()).padStart(2, "0")
  const month = String(date.getMonth() + 1).padStart(2, "0") // 月份从0开始
  const year = date.getFullYear()

  if (type === "hh:mm") {
    return `${hours}:${minutes}`
  } else if (type === "hh:mm:ss") {
    return `${hours}:${minutes}:${seconds}`
  } else if (type === "mm:ss") {
    return `${minutes}:${seconds}`
  } else if (type === "dd/mm/yyyy") {
    return `${day}/${month}/${year}`
  } else if (type === "dd/mm") {
    return `${day}/${month}`
  } else if (type === "mm/yyyy") {
    return `${month}/${year}`
  } else if (type === "dd/mm/yyyy hh:mm:ss") {
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
  } else {
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
  }
}
export default formatDate
